export const CONFIG_CONTRACT_TEMPLATE_DEFAULT_FILTER = {
  name: '',
  serviceId: '',
};
